// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/ecd5aef7f598eed2a5c9.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"624248f5c7b2520891e0","136":"005bad114d13b3c8ecfc","137":"d4523a0afa3d1e62fb0b"}[chunkId] + ".chunk.js";
};